export function isNotEmpty<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined
}

export { removeUndefinedValues } from '@reward-platform/tsutil'
